<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" [routerLink]="['/office/new-certification/detail', certification?.id]"
                      [queryParams]="{ tab: 'objectives' }">chevron_left</mat-icon>
            <h1 class="page-title">Edit Certification Target Objective</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/new-certification'">Certifications</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item mx-2" [routerLink]="['/office/new-certification/detail', certification?.id]"
                  [queryParams]="{ tab: 'objectives' }">{{certification?.certificationTitle}}</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item">{{domain?.domainName}}</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">Edit Objective</span>
        </div>
    </div>

    <hr class="mb-3" />

    <form [formGroup]="form">
        <div class="row ">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Certification Title</mat-label>
                    <input type="text" matInput formControlName="certificationTitle">
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Association</mat-label>
                    <mat-select formControlName="providerId">
                        <mat-option *ngFor="let assoc of associations" [value]="assoc.id">
                            {{ assoc.providerName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <h5 style="font-size: 16px" class="mt-2 text-white">Certification Domain and Objectives</h5>
        <mat-accordion class="mb-5" multi formArrayName="domains">
            <mat-expansion-panel [expanded]="true" *ngFor="let domain of domains.controls; let i = index" [formGroupName]="i">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="title-container">
                            <span>Domain </span>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="p-1 expansion-body">
                    <div class="row mt-4">
                        <div class="col-12">
                            <mat-form-field class="full-width w-100" appearance="outline">
                                <mat-label>Domain Name</mat-label>
                                <input type="text" matInput formControlName="domainName">
                            </mat-form-field>
                        </div>
                    </div>

                    <hr class="mb-3" />

                    <mat-accordion class="mb-5" multi formArrayName="objectives">
                        <mat-expansion-panel [expanded]="true" *ngFor="let objective of objectives(i).controls; let j = index" [formGroupName]="j">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <div class="title-container">
                                        <span>Target Objective </span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <div class="p-1 expansion-body">
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <mat-form-field class="full-width w-100" appearance="outline">
                                            <mat-label>Target Objective Name</mat-label>
                                            <input type="text" matInput formControlName="objectiveName">
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="col-12">
                                        <app-tiptap-editor
                                                placeholder="Enter your content here..."
                                                formControlName="term"
                                                label="Exam objective terms"
                                                [required]="true"
                                        >
                                        </app-tiptap-editor>
                                    </div>
                                </div>

                            </div>


                        </mat-expansion-panel>
                    </mat-accordion>


                </div>
            </mat-expansion-panel>


        </mat-accordion>


        <div class="row my-5">
            <div class="col-12 text-end">
                <button mat-raised-button (click)="saveDomain()" class="edit-button">Save</button>
            </div>
        </div>
    </form>
</div>

